import { getLocalStorageItem } from "../../storage";
import axios from 'axios';

export function headers() {
    const token = getLocalStorageItem('vp-portal-token');
    return {
        'Content-Type' : 'application/json',
        Authorization : `Bearer ${token}`
    }
};

export async function authFetch(url, options = {}) {
    return fetch(url, {
        ...options,
        headers: headers()
    })
};

export async function axiosAuthFetch(url, data = null, method = 'get') {

    try {
        const response = await axios({
            method: method,
            url: url,
            headers: headers(),
            data: data
        });
        return response.data;
    } catch(error) {
        console.error(error);
    }
};

export function imageHeaders() {
    const token = getLocalStorageItem('vp-portal-token');
    return {
        'Content-Type' : 'multipart/form-data',
        Authorization : `Bearer ${token}`
    }
};

export async function axiosImageAuthFetch(url, data = null, method = 'post') {

    try {
        const response = await axios({
            method: method,
            url: url,
            headers: imageHeaders(),
            data: data
        });
        return response.data;
    } catch(error) {
        console.error(error);
    }
};

export async function axiosAuthFetchDelete(url, method = 'delete') {
    try {
        const response = await axios({
            method,
            url,
            headers: headers()
        });
        return response;
    }catch(error){
        console.error(error);
    }
};

